<template>
  <div class="card-form">
    <page-main
      ref="main"
      :table-data="table"
      :loading="loading"
      @submit="reload"
      :tablePage="page"
      @export="exportData_"
    >
      <page-header
        @add="add"
        @reset="reset"
        slot="header"
        @submit="handleSubmit"
        ref="header"
      >
      </page-header>
      <pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        size="small"
        align="right"
        slot="pager"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>

<script>
import PageHeader from './components/header/index'
import PageMain from './components/main'

const initPage = {
  curPage: 1,
  pageSize: 20,
  pageTotal: 0,
};

export default {
  name: 'personal-my-recommend',
  components: {
    PageHeader,
    PageMain
  },
  data() {
    return {
      table: [],
      loading: false,
      page: {
        ...initPage
      }
    }
  },
  methods: {
    add() {
      this.$refs.main.fromLoad('add')
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    reset() {
      this.page = {
        ...initPage
      }
    },
    // 重载表格数据
    reload() {
      this.$refs.header.query()
    },
    // 加载表格数据
    handleSubmit(form) {
      this.loading = true
      this.$api
        .getListRecommend({
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    exportData_() {
      this.$refs.header.exportData_()
    }
  }
}
</script>
